import { render, staticRenderFns } from "./DealModalInformation.vue?vue&type=template&id=01299a80&scoped=true"
import script from "./DealModalInformation.vue?vue&type=script&lang=js"
export * from "./DealModalInformation.vue?vue&type=script&lang=js"
import style0 from "./DealModalInformation.vue?vue&type=style&index=0&id=01299a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01299a80",
  null
  
)

export default component.exports